<script>
  export let label = "";
  export let help = "";
  export let options = [];
  export let selected = [];
  export let single = false;
  export let onToggle = () => {};
</script>

<div class="company-info-choice">
  <span class="company-info-choice-label">{label} <span class="company-info-help" title={help}>?</span></span>
  <div class="company-info-option-grid">
    {#each options as option}
      {@const active = single ? selected === option : selected.includes(option)}
      <button type="button" class:active class="company-info-option" on:click={() => onToggle(option)}>{option}{#if active}<span>✓</span>{/if}</button>
    {/each}
  </div>
</div>

<style>
  .company-info-choice { display: flex; min-width: 0; flex-direction: column; gap: .75rem; }
  .company-info-choice > .company-info-choice-label { display: flex; align-items: center; flex-wrap: wrap; gap: .35rem; color: var(--pax-black); font-size: .75rem; font-weight: 400; line-height: 1.25; }
  .company-info-help { display: inline-flex; width: .95rem; height: .95rem; align-items: center; justify-content: center; border: 1px solid var(--pax-black); border-radius: 50%; color: var(--pax-black); cursor: help; font-size: .65rem; }
  .company-info-option-grid { display: flex; flex-wrap: wrap; gap: .5rem; }
  .company-info-option { display: inline-flex; min-height: 2.15rem; align-items: center; gap: .35rem; padding: .45rem .65rem; border: 1px solid var(--pax-black); border-radius: .5rem; background: var(--pax-white); color: var(--pax-black); cursor: pointer; font-size: .75rem; }
  .company-info-option.active { border-color: var(--pax-black); background: var(--pax-black); color: var(--pax-white); }
  .company-info-option.active span { color: var(--pax-white); font-weight: 700; }
</style>
